<div class="cellWrapper">
    {{ frequencyTranslationMap[$any(data).scheduleType] | translate }}
</div>
